import Vue from 'vue';

export default {
  SET_NORMALIZED_DATA(state: any, entities: any) {
    // for this mutation to work, state objects at ./state.ts
    // must have same names as normalized entities
    for (let key of Object.keys(entities)) {
      state[key] = { ...state[key], ...entities[key] };
    }
  },
  UPDATE_ENTITY(state: any, { entity, data }: any) {
    state[entity] = {
      ...state[entity],
      [data.id]: data,
    };
  },
  UPDATE_ENTITY_PROP(state: any, payload: any) {
    let { data, entity, propToUpdate, value } = payload;
    state[entity] = {
      ...state[entity],
      [data.id]: {
        ...data,
        [propToUpdate]: value,
      },
    };
  },
  DELETE_ENTITY(state: any, { entity, id }: any) {
    Vue.delete(state[entity], id);
  },
};
